import ArgonBox from 'component/Argon/ArgonBox';
import ArgonSelect from 'component/Argon/ArgonSelect';

/**
 * @typedef {{value: string, label: string}} ISelect
 *
 * @typedef IProps
 * @property {ISelect|undefined} value
 * @property {React.Dispatch<ISelect|undefined>} setValue
 *
 * @param {IProps} props
 */
function SelectAddress({ options, value, setValue }) {
  return (
    <ArgonBox>
      <ArgonSelect value={value} onChange={(v) => setValue(v)} defaultValue={options[1]} options={options} />
    </ArgonBox>
  );
}

export default SelectAddress;
